"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var CheckboxOn = function CheckboxOn(props) {
  return _react2["default"].createElement("svg", (0, _extends3["default"])({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _react2["default"].createElement("path", {
    className: "fill",
    d: "M2.564 0h10.872c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v10.873c0 .892-.093 1.215-.267 1.54-.174.327-.43.583-.756.757-.326.174-.65.267-1.54.267H2.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 0 1-.757-.756C.093 14.65 0 14.327 0 13.437V2.563c0-.892.093-1.215.267-1.54.174-.327.43-.583.756-.757C1.35.093 1.673 0 2.563 0zm4.088 10.894a.365.365 0 0 0 .514 0l4.727-4.764a.36.36 0 0 0 0-.511l-.514-.513a.365.365 0 0 0-.514 0L6.909 9.1 5.135 7.306a.365.365 0 0 0-.514 0l-.515.512a.362.362 0 0 0 0 .513l2.546 2.563z"
  }));
};

exports["default"] = CheckboxOn;